export enum SsoType {
	Google = 'Google',
	Microsoft = 'Microsoft',
}
